import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { AlertSubscriptionAction } from '../alertSubscription.action';

export const reloadSubscriptionsEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    AlertSubscriptionAction.addEmail.done,
    AlertSubscriptionAction.deleteEmail.done,
  ),
  mergeMap(() => {
    return [
      AlertSubscriptionAction.loadSubscriptions.started(),
    ];
  }),
);
